import React, { useEffect } from 'react'

import { Col, Container, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import { useContentWrapper } from '../common/ContentWrapperProvider'
import PublicLayout from '../common/PublicLayout'
import { StyledInfoPageHeaderWrapper } from '../common/styledComponents'

function PrivacyPolicyContentEn() {
    return (
        <>
                    <h2>Information on the Processing of Personal Data</h2>

                    <h3 className="mt-4">1. Controller</h3>
                    <p>
                        The controller of your personal data is <strong>The first million s. r. o.</strong>,
                        with its registered seat at Dolné Sľažany 317, 951 71 Sľažany, Slovak Republic,
                        Company ID (IČO): 54 616 913, registered in the Commercial Register of the District Court Nitra,
                        Section: Sro, Insert No.: 60864/N, operating the software application AMANI
                        (hereinafter the &quot;Controller&quot;).
                    </p>

                    <h3 className="mt-4">2. Purposes of Personal Data Processing</h3>
                    <p>
                        We process your personal data for the following purposes:
                    </p>
                    <ul>
                        <li>Operation and provision of the AMANI application&apos;s features, including management of your user account</li>
                        <li>Sign-in and synchronization with Google Calendar (see point 6a)</li>
                        <li>Management and operation of our social media profiles (Facebook, Instagram, LinkedIn)</li>
                        <li>Communication with users via social media</li>
                        <li>Analysis of website traffic and user behaviour</li>
                        <li>Improving our services and user experience</li>
                    </ul>

                    <h3 className="mt-4">3. Legal Basis for Processing</h3>
                    <p>
                        We process your personal data on the basis of:
                    </p>
                    <ul>
                        <li>Performance of a contract (Art. 6(1)(b) GDPR) – for providing the features of the AMANI application</li>
                        <li>Your consent (Art. 6(1)(a) GDPR)</li>
                        <li>Our legitimate interests (Art. 6(1)(f) GDPR)</li>
                    </ul>

                    <h3 className="mt-4">4. Categories of Personal Data Processed</h3>
                    <p>
                        We process the following categories of personal data:
                    </p>
                    <ul>
                        <li>Identification data (first name, surname, social media username)</li>
                        <li>Contact details (e-mail address, phone number, where provided)</li>
                        <li>Data from Google sign-in (name, e-mail address) and the authorization token for Google Calendar</li>
                        <li>Data on social media interactions (likes, comments, shares)</li>
                        <li>Technical data (IP address, browser type, cookies)</li>
                    </ul>

                    <h3 className="mt-4">5. Cookies</h3>
                    <p>
                        Our website uses cookies to ensure its proper functioning and to improve the user experience.
                    </p>
                    <h4 className="mt-3">Types of cookies we use:</h4>
                    <ul>
                        <li><strong>Necessary cookies:</strong> Required for the basic functionality of the website.</li>
                        <li><strong>Analytics cookies:</strong> Help us understand how you use our website.</li>
                        <li><strong>Marketing cookies:</strong> Used to display relevant advertisements.</li>
                    </ul>
                    <p>
                        You can manage your cookie preferences through your browser settings or through
                        our cookie management tool.
                    </p>

                    <h3 className="mt-4">6. Social Media and Third-Party Account Integration</h3>
                    <p>
                        We operate profiles on the following social media platforms:
                    </p>
                    <ul>
                        <li><strong>Facebook:</strong> Meta Platforms Ireland Limited</li>
                        <li><strong>Instagram:</strong> Meta Platforms Ireland Limited</li>
                        <li><strong>LinkedIn:</strong> LinkedIn Ireland Unlimited Company</li>
                        <li><strong>TikTok:</strong> TikTok Technology Limited</li>
                    </ul>
                    <p>
                        These platforms have their own privacy policies, which you can read on their respective websites.
                    </p>

                    <h3 className="mt-4">6a. Sign-in and Synchronization via Google Calendar</h3>
                    <p>
                        The AMANI application enables sign-in via a Google account and, in that context, accesses
                        the Google Calendar service for the purpose of synchronizing appointments and events.
                        Specifically, we use the following Google access scopes: auth/calendar, auth/userinfo.email,
                        and auth/userinfo.profile.
                    </p>
                    <p>Through these permissions, the application:</p>
                    <ul>
                        <li>reads existing events in your Google Calendar (e.g. to display availability),</li>
                        <li>creates, modifies, or deletes events in your Google Calendar (e.g. bookings, appointments),</li>
                        <li>obtains basic identification data from your Google account (first name, surname, e-mail address).</li>
                    </ul>
                    <p>
                        We do not permanently store your Google sign-in password or the content of your Google Calendar
                        database – we store only an authorization (access) token, which is used to verify our authorization
                        to access your calendar on behalf of the application. This token is stored securely and used
                        exclusively for calendar synchronization within the application&apos;s features.
                    </p>
                    <p>
                        Data obtained through Google (hereinafter &quot;Google user data&quot;) is processed exclusively
                        to the extent and for the purposes for which you granted consent at sign-in. We do not provide,
                        share, or otherwise transfer Google user data to third parties for advertising or marketing purposes,
                        and we do not transfer it to third countries outside the European Economic Area. The Controller
                        complies with Google&apos;s Limited Use Policy and uses Google user data exclusively to provide
                        or improve features visible to the user within the application.
                    </p>

                    <h3 className="mt-4">7. Security Measures</h3>
                    <p>
                        To protect your personal data, we apply in particular the following technical
                        and organizational measures:
                    </p>
                    <ul>
                        <li>encryption of data transmission via the HTTPS/TLS protocol,</li>
                        <li>sign-in secured through JWT tokens,</li>
                        <li>secure storage of data in a protected PostgreSQL database,</li>
                        <li>access-rights management ensuring that personal data can be accessed only by authorized individuals and services,</li>
                        <li>regular security updates, monitoring of systems, and adherence to established security best practices.</li>
                    </ul>

                    <h3 className="mt-4">8. Data Retention Period</h3>
                    <p>
                        We retain your personal data for as long as necessary to fulfil the purpose of processing,
                        or for the period for which you have granted us your consent.
                    </p>

                    <h3 className="mt-4">9. Your Rights</h3>
                    <p>
                        In connection with the processing of your personal data, you have the following rights:
                    </p>
                    <ul>
                        <li>Right of access to personal data</li>
                        <li>Right to rectification of incorrect data</li>
                        <li>Right to erasure of data (&quot;right to be forgotten&quot;)</li>
                        <li>Right to restriction of processing</li>
                        <li>Right to data portability</li>
                        <li>Right to object to processing</li>
                        <li>Right to withdraw consent</li>
                    </ul>

                    <h3 className="mt-4">10. Contact</h3>
                    <p>
                        If you have any questions regarding the processing of your personal data, you may contact us:
                    </p>
                    <ul>
                        <li>Phone: <strong>+421 948 944 724</strong></li>
                        <li>E-mail: <a href="mailto:pomozemti@amani.sk">pomozemti@amani.sk</a></li>
                    </ul>

                    <h3 className="mt-4">11. Supervisory Authority</h3>
                    <p>
                        If you believe that the processing of your personal data is in breach of applicable legal
                        regulations, you have the right to lodge a complaint with the Office for Personal Data Protection
                        of the Slovak Republic, with its registered seat at Hraničná 4826/12, 820 07 Bratislava,
                        Slovak Republic, telephone: +421 2 3231 3220,{' '}
                        <a href="https://www.dataprotection.gov.sk" target="_blank" rel="noreferrer">www.dataprotection.gov.sk</a>.
                    </p>

                    <p className="mt-4 text-muted">
                        <small>Last updated: August 2026</small>
                    </p>
        </>
    )
}

function PrivacyPolicyContentSk() {
    return (
        <>
                    <h2>Informácie o spracúvaní osobných údajov</h2>

                    <h3 className="mt-4">1. Prevádzkovateľ</h3>
                    <p>
                        Prevádzkovateľom vašich osobných údajov je spoločnosť <strong>The first million s. r. o.</strong>,
                        so sídlom Dolné Sľažany 317, 951 71 Sľažany, Slovenská republika, IČO: 54 616 913,
                        zapísaná v Obchodnom registri Okresného súdu Nitra, Oddiel: Sro, Vložka číslo: 60864/N,
                        prevádzkujúca softvérovú aplikáciu AMANI (ďalej len &quot;Prevádzkovateľ&quot;).
                    </p>

                    <h3 className="mt-4">2. Účely spracúvania osobných údajov</h3>
                    <p>
                        Vaše osobné údaje spracúvame na nasledovné účely:
                    </p>
                    <ul>
                        <li>Prevádzka a poskytovanie funkcií aplikácie AMANI, vrátane správy používateľského účtu</li>
                        <li>Prihlásenie a synchronizácia so službou Google Kalendár (pozri bod 6a)</li>
                        <li>Správa a prevádzka našich profilov na sociálnych sieťach (Facebook, Instagram, LinkedIn)</li>
                        <li>Komunikácia s používateľmi prostredníctvom sociálnych sietí</li>
                        <li>Analýza návštevnosti a správania používateľov na našich webových stránkach</li>
                        <li>Zlepšovanie našich služieb a používateľského zážitku</li>
                    </ul>

                    <h3 className="mt-4">3. Právny základ spracúvania</h3>
                    <p>
                        Vaše osobné údaje spracúvame na základe:
                    </p>
                    <ul>
                        <li>Plnenia zmluvy (čl. 6 ods. 1 písm. b) GDPR) – pri poskytovaní funkcií aplikácie AMANI</li>
                        <li>Vášho súhlasu (čl. 6 ods. 1 písm. a) GDPR)</li>
                        <li>Oprávnených záujmov Prevádzkovateľa (čl. 6 ods. 1 písm. f) GDPR)</li>
                    </ul>

                    <h3 className="mt-4">4. Kategórie spracúvaných osobných údajov</h3>
                    <p>
                        Spracúvame nasledovné kategórie osobných údajov:
                    </p>
                    <ul>
                        <li>Identifikačné údaje (meno, priezvisko, používateľské meno na sociálnych sieťach)</li>
                        <li>Kontaktné údaje (e-mailová adresa, telefónne číslo, ak boli poskytnuté)</li>
                        <li>Údaje z prihlásenia cez Google účet (meno, e-mailová adresa) a autorizačný token pre Google Kalendár</li>
                        <li>Údaje o interakcii na sociálnych sieťach (lajky, komentáre, zdieľania)</li>
                        <li>Technické údaje (IP adresa, typ prehliadača, cookies)</li>
                    </ul>

                    <h3 className="mt-4">5. Cookies</h3>
                    <p>
                        Naše webové stránky používajú cookies na zabezpečenie ich správnej funkčnosti
                        a na zlepšenie používateľského zážitku.
                    </p>
                    <h4 className="mt-3">Typy cookies, ktoré používame:</h4>
                    <ul>
                        <li><strong>Nevyhnutné cookies:</strong> Potrebné pre základnú funkčnosť webovej stránky.</li>
                        <li><strong>Analytické cookies:</strong> Pomáhajú nám pochopiť, ako používate našu webovú stránku.</li>
                        <li><strong>Marketingové cookies:</strong> Používajú sa na zobrazovanie relevantných reklám.</li>
                    </ul>
                    <p>
                        Svoje preferencie cookies môžete spravovať prostredníctvom nastavení vášho prehliadača alebo
                        prostredníctvom nášho nástroja na správu cookies.
                    </p>

                    <h3 className="mt-4">6. Sociálne siete a prepojenie účtov tretích strán</h3>
                    <p>
                        Prevádzkujeme profily na nasledovných sociálnych sieťach:
                    </p>
                    <ul>
                        <li><strong>Facebook:</strong> Meta Platforms Ireland Limited</li>
                        <li><strong>Instagram:</strong> Meta Platforms Ireland Limited</li>
                        <li><strong>LinkedIn:</strong> LinkedIn Ireland Unlimited Company</li>
                        <li><strong>TikTok:</strong> TikTok Technology Limited</li>
                    </ul>
                    <p>
                        Tieto platformy majú vlastné zásady ochrany osobných údajov, ktoré si môžete
                        prečítať na ich príslušných webových stránkach.
                    </p>

                    <h3 className="mt-4">6a. Prihlásenie a synchronizácia cez Google Kalendár</h3>
                    <p>
                        Aplikácia AMANI umožňuje prihlásenie prostredníctvom účtu Google a v jeho rámci pristupuje
                        k službe Google Kalendár (Google Calendar) na účely synchronizácie termínov a udalostí.
                        Konkrétne používame nasledujúce prístupové oprávnenia (scopes) služby Google:
                        auth/calendar, auth/userinfo.email a auth/userinfo.profile.
                    </p>
                    <p>Prostredníctvom týchto oprávnení aplikácia:</p>
                    <ul>
                        <li>číta existujúce udalosti vo Vašom Google kalendári (napr. na zobrazenie dostupnosti),</li>
                        <li>vytvára, upravuje alebo maže udalosti vo Vašom Google kalendári (napr. rezervácie, termíny),</li>
                        <li>získava základné identifikačné údaje z Vášho Google účtu (meno, priezvisko, e-mailová adresa).</li>
                    </ul>
                    <p>
                        Z prihlásenia cez Google si neukladáme Vaše prihlasovacie heslo ani obsah Vašej Google Kalendár
                        databázy trvalo – ukladáme si výlučne autorizačný (prístupový) token, ktorý nám slúži na overenie
                        oprávnenia pristupovať k Vášmu kalendáru v mene aplikácie. Tento token je uložený zabezpečene
                        a používame ho výlučne na účel synchronizácie kalendára v rámci funkcií aplikácie.
                    </p>
                    <p>
                        Údaje získané prostredníctvom Google (ďalej len &quot;Google user data&quot;) spracúvame výlučne
                        v rozsahu a na účely, na ktoré ste nám udelili súhlas pri prihlásení. Google user data
                        neposkytujeme, nezdieľame ani inak neprenášame tretím stranám na reklamné ani marketingové
                        účely a neprenášame ich do tretích krajín mimo Európskeho hospodárskeho priestoru.
                        Prevádzkovateľ dodržiava Zásady obmedzeného použitia (Limited Use) spoločnosti Google
                        a používa Google user data výlučne na poskytovanie alebo zlepšovanie funkcií viditeľných
                        pre používateľa v rámci aplikácie.
                    </p>

                    <h3 className="mt-4">7. Bezpečnostné opatrenia</h3>
                    <p>
                        Na ochranu Vašich osobných údajov uplatňujeme najmä nasledovné technické
                        a organizačné opatrenia:
                    </p>
                    <ul>
                        <li>šifrovanie prenosu údajov prostredníctvom protokolu HTTPS/TLS,</li>
                        <li>prihlasovanie zabezpečené prostredníctvom JWT tokenov,</li>
                        <li>bezpečné uloženie údajov v chránenej databáze PostgreSQL,</li>
                        <li>riadenie prístupových práv, ktoré umožňuje prístup k osobným údajom iba oprávneným osobám a službám,</li>
                        <li>pravidelné bezpečnostné aktualizácie, monitorovanie systémov a dodržiavanie osvedčených bezpečnostných postupov.</li>
                    </ul>

                    <h3 className="mt-4">8. Doba uchovávania osobných údajov</h3>
                    <p>
                        Vaše osobné údaje uchovávame po dobu nevyhnutnú na splnenie účelu spracúvania,
                        alebo po dobu, na ktorú ste nám udelili svoj súhlas.
                    </p>

                    <h3 className="mt-4">9. Vaše práva</h3>
                    <p>
                        V súvislosti so spracúvaním vašich osobných údajov máte nasledovné práva:
                    </p>
                    <ul>
                        <li>Právo na prístup k osobným údajom</li>
                        <li>Právo na opravu nesprávnych údajov</li>
                        <li>Právo na vymazanie údajov (&quot;právo na zabudnutie&quot;)</li>
                        <li>Právo na obmedzenie spracúvania</li>
                        <li>Právo na prenosnosť údajov</li>
                        <li>Právo namietať proti spracúvaniu</li>
                        <li>Právo odvolať súhlas</li>
                    </ul>

                    <h3 className="mt-4">10. Kontakt</h3>
                    <p>
                        Ak máte akékoľvek otázky týkajúce sa spracúvania vašich osobných údajov,
                        môžete nás kontaktovať:
                    </p>
                    <ul>
                        <li>Telefón: <strong>+421 948 944 724</strong></li>
                        <li>E-mail: <a href="mailto:pomozemti@amani.sk">pomozemti@amani.sk</a></li>
                    </ul>

                    <h3 className="mt-4">11. Dozorný orgán</h3>
                    <p>
                        Ak sa domnievate, že spracúvanie vašich osobných údajov je v rozpore s platnými právnymi
                        predpismi, máte právo podať sťažnosť na Úrad na ochranu osobných údajov Slovenskej republiky,
                        so sídlom Hraničná 4826/12, 820 07 Bratislava, Slovenská republika, telefónne číslo:
                        +421 2 3231 3220,{' '}
                        <a href="https://www.dataprotection.gov.sk" target="_blank" rel="noreferrer">www.dataprotection.gov.sk</a>.
                    </p>

                    <p className="mt-4 text-muted">
                        <small>Posledná aktualizácia: august 2026</small>
                    </p>
        </>
    )
}

function PrivacyPolicyContentCs() {
    return (
        <>
                    <h2>Informace o zpracování osobních údajů</h2>

                    <p className="text-muted">
                        (Tento dokument je českým překladem zásad ochrany osobních údajů, které se řídí právním
                        řádem Slovenské republiky, neboť společnost je usazena a poskytuje služby ze Slovenské republiky.)
                    </p>

                    <h3 className="mt-4">1. Správce</h3>
                    <p>
                        Správcem vašich osobních údajů je společnost <strong>The first million s. r. o.</strong>,
                        se sídlem Dolné Sľažany 317, 951 71 Sľažany, Slovenská republika, IČO: 54 616 913,
                        zapsaná v Obchodním rejstříku Okresního soudu Nitra, Oddíl: Sro, Vložka číslo: 60864/N,
                        provozující softwarovou aplikaci AMANI (dále jen &quot;Správce&quot;).
                    </p>

                    <h3 className="mt-4">2. Účely zpracování osobních údajů</h3>
                    <p>
                        Vaše osobní údaje zpracováváme k následujícím účelům:
                    </p>
                    <ul>
                        <li>Provoz a poskytování funkcí aplikace AMANI, včetně správy uživatelského účtu</li>
                        <li>Přihlášení a synchronizace se službou Google Kalendář (viz bod 6a)</li>
                        <li>Správa a provoz našich profilů na sociálních sítích (Facebook, Instagram, LinkedIn)</li>
                        <li>Komunikace s uživateli prostřednictvím sociálních sítí</li>
                        <li>Analýza návštěvnosti a chování uživatelů na našich webových stránkách</li>
                        <li>Zlepšování našich služeb a uživatelského zážitku</li>
                    </ul>

                    <h3 className="mt-4">3. Právní základ zpracování</h3>
                    <p>
                        Vaše osobní údaje zpracováváme na základě:
                    </p>
                    <ul>
                        <li>Plnění smlouvy (čl. 6 odst. 1 písm. b) GDPR) – při poskytování funkcí aplikace AMANI</li>
                        <li>Vašeho souhlasu (čl. 6 odst. 1 písm. a) GDPR)</li>
                        <li>Oprávněných zájmů Správce (čl. 6 odst. 1 písm. f) GDPR)</li>
                    </ul>

                    <h3 className="mt-4">4. Kategorie zpracovávaných osobních údajů</h3>
                    <p>
                        Zpracováváme následující kategorie osobních údajů:
                    </p>
                    <ul>
                        <li>Identifikační údaje (jméno, příjmení, uživatelské jméno na sociálních sítích)</li>
                        <li>Kontaktní údaje (e-mailová adresa, telefonní číslo, pokud byly poskytnuty)</li>
                        <li>Údaje z přihlášení přes Google účet (jméno, e-mailová adresa) a autorizační token pro Google Kalendář</li>
                        <li>Údaje o interakci na sociálních sítích (lajky, komentáře, sdílení)</li>
                        <li>Technické údaje (IP adresa, typ prohlížeče, cookies)</li>
                    </ul>

                    <h3 className="mt-4">5. Cookies</h3>
                    <p>
                        Naše webové stránky používají cookies k zajištění jejich správné funkčnosti
                        a ke zlepšení uživatelského zážitku.
                    </p>
                    <h4 className="mt-3">Typy cookies, které používáme:</h4>
                    <ul>
                        <li><strong>Nezbytné cookies:</strong> Potřebné pro základní funkčnost webové stránky.</li>
                        <li><strong>Analytické cookies:</strong> Pomáhají nám pochopit, jak používáte naši webovou stránku.</li>
                        <li><strong>Marketingové cookies:</strong> Používají se k zobrazování relevantních reklam.</li>
                    </ul>
                    <p>
                        Své preference ohledně cookies můžete spravovat prostřednictvím nastavení svého prohlížeče
                        nebo prostřednictvím našeho nástroje pro správu cookies.
                    </p>

                    <h3 className="mt-4">6. Sociální sítě a propojení účtů třetích stran</h3>
                    <p>
                        Provozujeme profily na následujících sociálních sítích:
                    </p>
                    <ul>
                        <li><strong>Facebook:</strong> Meta Platforms Ireland Limited</li>
                        <li><strong>Instagram:</strong> Meta Platforms Ireland Limited</li>
                        <li><strong>LinkedIn:</strong> LinkedIn Ireland Unlimited Company</li>
                        <li><strong>TikTok:</strong> TikTok Technology Limited</li>
                    </ul>
                    <p>
                        Tyto platformy mají vlastní zásady ochrany osobních údajů, které si můžete přečíst
                        na jejich příslušných webových stránkách.
                    </p>

                    <h3 className="mt-4">6a. Přihlášení a synchronizace přes Google Kalendář</h3>
                    <p>
                        Aplikace AMANI umožňuje přihlášení prostřednictvím účtu Google a v jeho rámci přistupuje
                        ke službě Google Kalendář (Google Calendar) za účelem synchronizace termínů a událostí.
                        Konkrétně používáme následující přístupová oprávnění (scopes) služby Google:
                        auth/calendar, auth/userinfo.email a auth/userinfo.profile.
                    </p>
                    <p>Prostřednictvím těchto oprávnění aplikace:</p>
                    <ul>
                        <li>čte existující události ve vašem Google kalendáři (např. pro zobrazení dostupnosti),</li>
                        <li>vytváří, upravuje nebo maže události ve vašem Google kalendáři (např. rezervace, termíny),</li>
                        <li>získává základní identifikační údaje z vašeho Google účtu (jméno, příjmení, e-mailová adresa).</li>
                    </ul>
                    <p>
                        Z přihlášení přes Google si neukládáme vaše přihlašovací heslo ani obsah vaší databáze
                        Google Kalendáře trvale – ukládáme si výhradně autorizační (přístupový) token, který nám
                        slouží k ověření oprávnění přistupovat k vašemu kalendáři jménem aplikace. Tento token
                        je uložen zabezpečeně a používáme ho výhradně za účelem synchronizace kalendáře v rámci
                        funkcí aplikace.
                    </p>
                    <p>
                        Údaje získané prostřednictvím Google (dále jen &quot;Google user data&quot;) zpracováváme
                        výhradně v rozsahu a k účelům, ke kterým jste nám udělili souhlas při přihlášení.
                        Google user data neposkytujeme, nesdílíme ani jinak nepřenášíme třetím stranám k reklamním
                        ani marketingovým účelům a nepřenášíme je do třetích zemí mimo Evropský hospodářský prostor.
                        Správce dodržuje Zásady omezeného použití (Limited Use) společnosti Google a používá
                        Google user data výhradně k poskytování nebo zlepšování funkcí viditelných pro uživatele
                        v rámci aplikace.
                    </p>

                    <h3 className="mt-4">7. Bezpečnostní opatření</h3>
                    <p>
                        K ochraně vašich osobních údajů uplatňujeme zejména následující technická
                        a organizační opatření:
                    </p>
                    <ul>
                        <li>šifrování přenosu údajů prostřednictvím protokolu HTTPS/TLS,</li>
                        <li>přihlašování zabezpečené prostřednictvím JWT tokenů,</li>
                        <li>bezpečné uložení údajů v chráněné databázi PostgreSQL,</li>
                        <li>řízení přístupových práv, které umožňuje přístup k osobním údajům pouze oprávněným osobám a službám,</li>
                        <li>pravidelné bezpečnostní aktualizace, monitorování systémů a dodržování osvědčených bezpečnostních postupů.</li>
                    </ul>

                    <h3 className="mt-4">8. Doba uchovávání osobních údajů</h3>
                    <p>
                        Vaše osobní údaje uchováváme po dobu nezbytnou ke splnění účelu zpracování,
                        nebo po dobu, na kterou jste nám udělili svůj souhlas.
                    </p>

                    <h3 className="mt-4">9. Vaše práva</h3>
                    <p>
                        V souvislosti se zpracováním vašich osobních údajů máte následující práva:
                    </p>
                    <ul>
                        <li>Právo na přístup k osobním údajům</li>
                        <li>Právo na opravu nesprávných údajů</li>
                        <li>Právo na výmaz údajů (&quot;právo být zapomenut&quot;)</li>
                        <li>Právo na omezení zpracování</li>
                        <li>Právo na přenositelnost údajů</li>
                        <li>Právo namítat proti zpracování</li>
                        <li>Právo odvolat souhlas</li>
                    </ul>

                    <h3 className="mt-4">10. Kontakt</h3>
                    <p>
                        Máte-li jakékoli dotazy týkající se zpracování vašich osobních údajů,
                        můžete nás kontaktovat:
                    </p>
                    <ul>
                        <li>Telefon: <strong>+421 948 944 724</strong></li>
                        <li>E-mail: <a href="mailto:pomozemti@amani.sk">pomozemti@amani.sk</a></li>
                    </ul>

                    <h3 className="mt-4">11. Dozorový úřad</h3>
                    <p>
                        Domníváte-li se, že zpracování vašich osobních údajů je v rozporu s platnými právními
                        předpisy, máte právo podat stížnost u Úřadu na ochranu osobních údajů Slovenské republiky,
                        se sídlem Hraničná 4826/12, 820 07 Bratislava, Slovenská republika, telefonní číslo:
                        +421 2 3231 3220,{' '}
                        <a href="https://www.dataprotection.gov.sk" target="_blank" rel="noreferrer">www.dataprotection.gov.sk</a>.
                    </p>

                    <p className="mt-4 text-muted">
                        <small>Poslední aktualizace: srpen 2026</small>
                    </p>
        </>
    )
}

function PrivacyPolicyPage() {
    const contentWrapper = useContentWrapper()
    const { i18n } = useTranslation()

    const isEn = i18n.language === 'en'
    const isCs = i18n.language === 'cs'

    const title = isEn
        ? 'Amani Privacy Policy'
        : isCs
            ? 'Amani – Zásady ochrany osobních údajů'
            : 'Amani – Zásady ochrany osobných údajov'

    useEffect(() => {
        contentWrapper.setNoBootstrapColumns(true)

        const previousTitle = document.title
        document.title = 'Amani Privacy Policy'

        return () => {
            contentWrapper.setNoBootstrapColumns(false)
            document.title = previousTitle
        }
    }, [])

    return (
        <PublicLayout>
            <div className="info-page">
                <StyledInfoPageHeaderWrapper>
                    <Container>
                        <Row>
                            <Col>
                                <h1>{title}</h1>
                            </Col>
                        </Row>
                    </Container>
                </StyledInfoPageHeaderWrapper>
                <Container>
                    <div className="rounded-content-body mt-3 p-4">
                        <Row>
                            <Col>
                                {isEn ? <PrivacyPolicyContentEn /> : isCs ? <PrivacyPolicyContentCs /> : <PrivacyPolicyContentSk />}
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>
        </PublicLayout>
    )
}

export default PrivacyPolicyPage
